import { render, staticRenderFns } from "./joinStart.vue?vue&type=template&id=37beb37e&scoped=true"
import script from "./joinStart.vue?vue&type=script&lang=js"
export * from "./joinStart.vue?vue&type=script&lang=js"
import style0 from "./joinStart.vue?vue&type=style&index=0&id=37beb37e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37beb37e",
  null
  
)

export default component.exports